export const dateFormatter = (language: string, date: any) => {
  const formattedDate = date.toLocaleDateString(language, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  return formattedDate;
};
